import { CustomButton } from "@/utils/buttons/custom-button";

export class CustomButtonWrapper {
	Browse1: CustomButton[] = [];
	Browse2: CustomButton[] = [];
	Browse3: CustomButton[] = [];
	Browse4: CustomButton[] = [];
	Browse5: CustomButton[] = [];
	Browse6: CustomButton[] = [];
	Browse7: CustomButton[] = [];
	Browse8: CustomButton[] = [];
	Browse9: CustomButton[] = [];
	Browse10: CustomButton[] = [];
	Browse11: CustomButton[] = [];
	Browse12: CustomButton[] = [];
	Browse23: CustomButton[] = [];

	public constructor(data?: any) {
		if (!data || !data.Browse1) return;

		this.Browse1 = data["Browse1"]?.map((c: CustomButton) => new CustomButton(c)) || [];
		this.Browse2 = data["Browse2"]?.map((c: CustomButton) => new CustomButton(c)) || [];
		this.Browse3 = data["Browse3"]?.map((c: CustomButton) => new CustomButton(c)) || [];
		this.Browse4 = data["Browse4"]?.map((c: CustomButton) => new CustomButton(c)) || [];
		this.Browse5 = data["Browse5"]?.map((c: CustomButton) => new CustomButton(c)) || [];
		this.Browse6 = data["Browse6"]?.map((c: CustomButton) => new CustomButton(c)) || [];
		this.Browse7 = data["Browse7"]?.map((c: CustomButton) => new CustomButton(c)) || [];
		this.Browse8 = data["Browse8"]?.map((c: CustomButton) => new CustomButton(c)) || [];
		this.Browse9 = data["Browse9"]?.map((c: CustomButton) => new CustomButton(c)) || [];
		this.Browse10 = data["Browse10"]?.map((c: CustomButton) => new CustomButton(c)) || [];
		this.Browse11 = data["Browse11"]?.map((c: CustomButton) => new CustomButton(c)) || [];
		this.Browse12 = data["Browse12"]?.map((c: CustomButton) => new CustomButton(c)) || [];
		this.Browse23 = data["Browse23"]?.map((c: CustomButton) => new CustomButton(c)) || [];
	}

	public getJSON() {
		return {
			Browse1: this.Browse1,
			Browse2: this.Browse2,
			Browse3: this.Browse3,
			Browse4: this.Browse4,
			Browse5: this.Browse5,
			Browse6: this.Browse6,
			Browse7: this.Browse7,
			Browse8: this.Browse8,
			Browse9: this.Browse9,
			Browse10: this.Browse10,
			Browse11: this.Browse11,
			Browse12: this.Browse12,
			Browse23: this.Browse23
		};
	}

	public getButtonsForBrowse(browseId: number): CustomButton[] {
		if (!(this as any)["Browse" + browseId]) return [];
		return (this as any)["Browse" + browseId];
	}
}
